import { render, staticRenderFns } from "./RequestDetailsToken.vue?vue&type=template&id=3d6f8dec&scoped=true"
import script from "./RequestDetailsToken.vue?vue&type=script&lang=ts"
export * from "./RequestDetailsToken.vue?vue&type=script&lang=ts"
import style0 from "./RequestDetailsToken.vue?vue&type=style&index=0&id=3d6f8dec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6f8dec",
  null
  
)

export default component.exports